const LOGO = "/assets/logo-nostradamus-oficial.png?v=3";

export default function LogoMark({ small = false }) {
  if (small) {
    return (
      <div
        className="flex items-center gap-2.5"
        data-testid="logo-mark-small"
        aria-label="LSC EGN"
      >
        <img src={LOGO} alt="LSC/EGN" className="w-9 h-9 object-contain" />
        <div className="leading-tight">
          <div className="font-display font-bold text-[var(--text)] text-sm tracking-wide">
            NOSTRADAMUS
          </div>
          <div className="label-mil text-[10px]">LSC / EGN</div>
        </div>
      </div>
    );
  }
  return (
    <div className="flex items-center gap-4" data-testid="logo-mark">
      <img src={LOGO} alt="LSC/EGN" className="w-14 h-14 object-contain" />
      <div>
        <div className="font-display font-bold text-[var(--text)] text-lg leading-none tracking-wide">
          PROJETO NOSTRADAMUS
        </div>
        <div className="label-mil mt-1">
          Laboratório de Simulações e Cenários · EGN
        </div>
      </div>
    </div>
  );
}
